// extracted by mini-css-extract-plugin
export default {"container":"ReviewInfoBlock_container__+vPVT","mainBlock":"ReviewInfoBlock_mainBlock__jM3PI","btn":"ReviewInfoBlock_btn__bDv4S"};